import * as React from 'react'
import type { InputDescriptionProps } from '../../../components/InputDescription'
import { useDsUiDataProps, useThemeStyles } from '../../../theming'
import type { InputLabelProps } from '../InputLabel'
import styles from './styles'

export interface AboveInputContainerProps {
  /**
   * Accepts custom data attributes.
   */
  'data-.*'?: string
  'data-qa'?: string
  description?: React.ReactElement<InputDescriptionProps>
  hideLabel?: boolean
  label?: React.ReactElement<InputLabelProps> | HTMLLegendElement
}

export function AboveInputContainer({
  'data-qa': dataQa,
  description,
  hideLabel = false,
  label,
}: AboveInputContainerProps) {
  const sx = useThemeStyles(styles, {
    hideLabel,
    description,
  })
  const dsUiDataProps = useDsUiDataProps(AboveInputContainer)

  return label || description ? (
    <div css={sx.wrap} data-qa={dataQa} {...dsUiDataProps}>
      {label}
      {description}
    </div>
  ) : null
}

AboveInputContainer.displayName = 'AboveInputContainer'
